const socials = [
  {
    name: "Instagram",
    icon: "ri-instagram-line",
    href: "https://www.instagram.com/nimasdirang",
    color: "hover:bg-gradient-to-br hover:from-purple-500 hover:via-pink-500 hover:to-orange-400 hover:text-white",
  },
  {
    name: "Facebook",
    icon: "ri-facebook-fill",
    href: "https://www.facebook.com/nimas2018",
    color: "hover:bg-blue-600 hover:text-white",
  },
  {
    name: "YouTube",
    icon: "ri-youtube-fill",
    href: "https://www.youtube.com/@nimasdirang",
    color: "hover:bg-red-600 hover:text-white",
  },
  {
    name: "X / Twitter",
    icon: "ri-twitter-x-fill",
    href: "https://x.com/dirangnimas?lang=en",
    color: "hover:bg-gray-900 hover:text-white",
  },
];

export default function FloatingSocialIcons() {
  return (
    <div className="fixed right-4 top-1/2 -translate-y-1/2 z-40 flex flex-col gap-1.5">
      {socials.map((s) => (
        <a
          key={s.name}
          href={s.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Follow NIMAS on ${s.name}`}
          title={s.name}
          className={`w-10 h-10 flex items-center justify-center rounded-xl bg-white border border-gray-200 text-gray-500 shadow-sm transition-all duration-300 cursor-pointer group ${s.color}`}
        >
          <i className={`${s.icon} text-base transition-transform duration-300 group-hover:scale-110`} />
        </a>
      ))}
    </div>
  );
}